/* @flow strict */

/* eslint-disable camelcase */
import * as React from 'react';
import Modal from '/client/src/components/Modal';

import '../styles.scss';
import { PUT } from '/client/src/api';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import _ from 'lodash';
import CssPinner from '/client/src/components/csspinner';
import NProgressCustom from '/client/src/components/nProgress';

type PropsType = {
  isOpen: boolean,
  handleShowModal: (boolean) => void,
  theme: string | null,
  upThemeData: () => void,
  eventId: string | number,
  onThemeUpdate: () => void
};

class EventPageTicketPreviewThemeModal extends React.Component<PropsType> {
  static contextType = DefaultContainerContext;

  handleClose = (): any => {
    const { handleShowModal } = this.props;

    // fallback if user doesnt click save after change theme
    this.props.upThemeData(this.props.theme);

    handleShowModal(false);
  };

  handleSave = async () => {
    try {
      CssPinner(document.body, true);
      NProgressCustom(true);

      await PUT(`/api/v1/1/splashpages/${this.props.eventId}`, {
        id: this.props.eventId,
        is_active: true,
        theme: this.props.theme
      });

      this.handleClose();

      CssPinner(document.body, false);
      NProgressCustom(false);

      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Successfully'
      });
      this.props.onThemeUpdate();
    } catch (errors) {
      CssPinner(document.body, false);
      NProgressCustom(false);

      console.log(errors);
      console.error('Can\'t save theme');

      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: !errors ?
          'Can\'t save theme' :
          _.map(errors, (er: {}): string => `${er.message}\n\n`)
      });
    }
  };

  render(): React.Element<'div'> {
    const { isOpen, theme, upThemeData } = this.props;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
      >
        <div
          className="modal-dialog customModal EventPageTicketPreviewThemeModal splash-editor-modal"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <span>Choose a theme for your splash page</span>
              </h4>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <div className="row">
                  <label htmlFor="ck_sp_theme_dark" className="col-xs-6 text-center">
                    <i className="splash-theme-dark" />
                    <label className="icheckbox">
                      <input
                        type="radio"
                        id="ck_sp_theme_dark"
                        value="Dark"
                        name="ko_unique_1"
                        checked={theme === 'Dark'}
                        onChange={() => {
                          upThemeData('Dark');
                        }}
                      />
                      <i className="icheckbox-icon" />
                      <span className="cursor-pointer" />
                    </label>
                  </label>

                  <label htmlFor="ck_sp_theme_light" className="col-xs-6 text-center">
                    <i className="splash-theme-light" />
                    <label className="icheckbox">
                      <input
                        type="radio"
                        id="ck_sp_theme_light"
                        value="Light"
                        name="ko_unique_2"
                        checked={theme === 'Light'}
                        onChange={() => {
                          upThemeData('Light');
                        }}
                      />
                      <i className="icheckbox-icon" />
                      <span className="cursor-pointer" />
                    </label>
                  </label>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Cancel</button>
              <button
                className="btn btn-pink"
                onClick={this.handleSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EventPageTicketPreviewThemeModal;
